/**
 * This function returns the full name as a string.
 * @param {String} firstname
 * @param {String | null} insertion
 * @param {String} lastname
 * @returns
 */
export const getFullname = (firstname, insertion, lastname) => {
  let val = "";
  val += firstname + " ";
  if (insertion) val += insertion + " ";
  val += lastname;

  return val;
};
